<template>
  <div v-if="json.length > 0">
    <b-modal id="accomodation-info-modal" ref="accomodation-info-modal-ref" hide-footer v-bind:title="name"
      modal-class="modal-centered mb-0 pb-0 no-scroll">
      <div slot="modal-title">
        <span v-bind:title="name" class="modal-title">
          {{ name }}
          <span class="text-nowrap">
            <span class="ml-1" v-html="star_rating_grade"> </span>
            <span class="ml-1" v-html="hot_type"> </span>
          </span>
        </span>
      </div>

      <div id="gallery" class="gal d-block">
        <div class="view-preview">
          <i class="material-icons align-middle">close</i>
          <span>close gallery</span>
        </div>
        <div class="blown-up">
          <i class="material-icons align-middle">close</i>
          <span>close this image</span>
        </div>
        <div class="gal-prev"><i class="material-icons">arrow_back_ios</i></div>
        <div class="gal-next">
          <i class="material-icons">arrow_forward_ios</i>
        </div>
        <div class="row gal-wrapper gal-closed g-0 m-0" v-html="galleryHTML"></div>
      </div>

      <div class="hotel-content">
        <div>
          <b-card no-body>
            <b-tabs card lazy class="o-back">
              <b-tab title="Trailfinders View" active>
                <b-card-text>
                  <section class="content-scroll p-3">
                    <div class="row">
                      <div class="col col-12">
                        <p v-html="tfviewHTML"></p>
                      </div>
                    </div>
                  </section>
                </b-card-text>
              </b-tab>

              <b-tab title="Location" v-if="address">
                <b-card-text>
                  <section class="content-scroll p-3">
                    <div class="row">
                      <div class="col col-12">
                        <p>{{ location }}</p>
                        <p>{{ address }}</p>
                        <p>{{ continent }}</p>
                      </div>
                    </div>
                  </section>
                </b-card-text>
              </b-tab>

              <b-tab title="Rooms">
                <b-card-text>
                  <section class="content-scroll p-3">
                    <div class="row">
                      <div class="col col-12">
                        <p v-html="roomsHTML"></p>
                        <p v-html="villasHTML"></p>
                      </div>
                    </div>
                  </section>
                </b-card-text>
              </b-tab>

              <b-tab title="Features">
                <b-card-text>
                  <section class="content-scroll">
                    <ul class="p-0 m-0 d-flex flex-wrap justify-content-center align-items-center"
                      v-html="highlightsHTML"></ul>
                  </section>
                </b-card-text>
              </b-tab>
              <b-tab title="Map" id="map-tab" class="p-2" @click="openMap(mapData)">
                <b-card-text>
                  <section>
                    <div class="row">
                      <div class="col col-12">
                        <MapTab ref="MapTab" />
                      </div>
                    </div>
                  </section>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-card>
        </div>
      </div>
      <!--hotel-content-->
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import MapTab from "@/partials/map-tab";
export default {
  components: {
    MapTab,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
    itemtype: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      hotelInfo: null,
      name: null,
      location: null,
      carouselHTML: null,
      rooms: null,
      roomsHTML: null,
      villas: null,
      villasHTML: null,
      rating: null,
      star_rating: null,
      style: null,
      highlights: null,
      highlightsHTML: null,
      description: null,
      json: [],
      address: "",
    };
  },
  mounted() {
    let json = [];
  },
  computed: {
    mapData() {
      if (this.geocode) {
        const coords = this.geocode.split(", ");
        return {
          lat: parseFloat(coords[0]),
          lng: parseFloat(coords[1]),
          zoom: 16,
        };
      }
      return null;
    },
    ...mapGetters({
      bookingNumber: "booking/getBookingNumber",
      essInfo: "booking/getEssentialInfo",
      essentialInfoMenu: "essentialInfoMenu/getMenu",
      fil: "booking/getFil",
    }),
  },
  methods: {
    openMap(mapData) {
      setTimeout(() => {
        this.$refs.MapTab.show(mapData);
      });
    },

    formatRoomCopy(copy) {
      // Each room/villa is a paragraph separated by a blank line. Within a
      // paragraph only the room name — the label up to and including the first
      // colon — is bold. Colons that are part of a URL (e.g. https://) are
      // ignored, and paragraphs without a label colon are left unstyled so the
      // bold never bleeds into the description or following paragraphs.
      /*return copy
        .split(/\r\n\r\n/)
        .map((paragraph) => {
          const labelMatch = paragraph.match(/^(.*?[^/]:)(?!\/)/);
          if (!labelMatch) {
            return paragraph;
          }
          const label = labelMatch[1];
          return `<strong>${label}</strong>${paragraph.slice(label.length)}`;
        })
        .join("</p><p>");*/
      //Simplified formatting: task 497. Code left above as I am not sure we will want to revert to the old formatting at some point.
      return copy.replace(/\r\n/g, "<br/>");
    },

    show(htlpagelink) {
      fetch(
        `https://www.trailfinders.com/webdata/hotels/supplierforVT/${htlpagelink}`
      )
        .then((r) => r.json())
        .then((json) => {
          this.json = json;
          if (json[0]) {
            this.name = json[0].name;
            this.geocode = json[0].geocode;

            // The feed exposes the gallery as a flat [url, caption, url, ...]
            // array. Newer records use `imagemain`; older ones used
            // `CDNimagemain`, so fall back to keep both working.
            this.gallery = json[0].CDNimagemain || json[0].imagemain;
            const galleryObj = {};
            galleryObj.imageGallery = [];
            galleryObj.imageGalleryCaption = [];
            let singleCaption = galleryObj.imageGalleryCaption[0];
            let singleImage = galleryObj.imageGallery[0];

            if (this.gallery && this.gallery.length > 0) {
              if (!Array.isArray(this.gallery)) {
                // if only 1 image in the gallery, shove it into an array so that the gallery can cope.
                const imagegallery = [];
                imagegallery.push(this.gallery);
                singleImage = this.gallery;
              } else {
                for (var i = 0; i < this.gallery.length; i++) {
                  // hide videos from the gallery
                  if (this.gallery[i].endsWith('mp4') || this.gallery[i].endsWith('m3u8')) {
                    this.gallery.splice(i, 1 + 1);
                    i--;
                  }
                }
                this.gallery.forEach((item) => {
                  if (item.slice(0, 4) === "http") {
                    galleryObj.imageGallery.push(item);
                  }
                });
                this.gallery.forEach((option) => {
                  if (option.slice(0, 4) !== "http") {
                    galleryObj.imageGalleryCaption.push(option);
                  }
                });
                if (galleryObj.imageGallery.length === 1) {
                  //galleryObj.imageGallery.push(singleImage)
                }
                singleImage = galleryObj.imageGallery[0];
                singleCaption = galleryObj.imageGalleryCaption[0];
              }
            }
            const images = galleryObj.imageGallery;
            const preview_images = images.shift();
            const captions = galleryObj.imageGalleryCaption;
            const preview_captions = captions.shift();
            var slides = [],
              main_image = "",
              html = "",
              close = "";
            main_image = '<div class="gal-main col col-8 p-0">';
            main_image +=
              '<img src="' +
              singleImage +
              '?width=640" alt=" ' +
              singleCaption +
              '"/>';
            main_image += "</div>";
            main_image += '<div class="gal-preview col col-4 p-0">';
            main_image += '<ul class="gal-items">';
            for (var i in images) {
              // set up the slide

              html = '<li class="gal-img">';
              html +=
                '<img src="' +
                images[i] +
                '?width=777" alt="' +
                captions[i] +
                '">';
              html +=
                '<div class="overlay"><span>' + captions[i] + "</span></div>";
              html += "</li>";
              slides.push(html);
            }
            close +=
              '</ul></div><div class="view-all" ><i class="material-icons camera align-middle">camera</i> <span>view all</span></div>';
            this.galleryHTML = main_image + slides.join("") + close;
            if (json[0].Location) {
              this.location = json[0].Location;
            }
            if (json[0].continent) {
              this.continent = json[0].continent;
            }
            if (json[0].address && typeof json[0].address === 'string' && json[0].address.trim() && !json[0].address.toUpperCase().includes("ERROR")) {
              this.address = json[0].address;
            }

            if (json[0].Rooms) {
              this.roomsHTML = this.formatRoomCopy(json[0].Rooms);
            }

            if (!json[0].Rooms && json[0].VillasCopy) {
              this.villasHTML = this.formatRoomCopy(json[0].VillasCopy);
            }
            if (json[0].classification) {
              this.rating = this.json[0].classification;
              this.star_rating = json[0].classification.replace(/\s+/g, "-");
              this.star_rating_grade = json[0].classification.replace("plus star", "star plus").replace(
                "star",
                '<span class="material-symbols-outlined align-middle mt-2-neg ml-1-neg">grade</span>'
              );
            }
            if (json[0].DDHoteltype) {
              let hotType = json[0].DDHoteltype
              if (hotType.includes("Adults_Only; Boutique")) {
                hotType = hotType.replace("Adults_Only; Boutique", "Adults Only Boutique")
              } else if (hotType.includes("Familyfavourite")) {
                hotType = hotType.replace("Familyfavourite", "Family Favourite");
              }
              this.hot_type = hotType
            }
            if (json[0].style) {
              this.style = this.json[0].style;
            }
            if (json[0].highlights) {
              this.highlights = json[0].highlights.split(/(?:\r\n|\r|\n)/g);
              const formatted_highlights = [];
              this.highlights.forEach((hl) => {
                const x = hl.toLowerCase();
                if (x.includes("wi-fi")) {
                  hl =
                    '<i class="material-icons align-middle">wifi</i>&nbsp;' +
                    hl;
                }
                if (x.includes("lounge") && !x.includes("bar")) {
                  hl =
                    '<i class="material-icons align-middle">chair</i>&nbsp;' +
                    hl;
                } else if (x.includes("lounge") && x.includes("bar")) {
                  hl =
                    '<i class="material-icons align-middle">liquor</i>&nbsp;' +
                    hl;
                } else if (
                  x.includes("bar") &&
                  !x.includes("lounge") &&
                  !x.includes("becue")
                ) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">liquor</i>&nbsp;' +
                    hl;
                } else if (x.includes("bar") && !x.includes("becue")) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">outdoor_grill</i>&nbsp;' +
                    hl;
                } else if (x.includes("restaurant") && x.includes("bar")) {
                  hl =
                    '<i class="material-icons align-middle">restaurant</i>&nbsp;' +
                    hl;
                } else if (x.includes("restaurant") && x.includes("café")) {
                  hl =
                    '<i class="material-icons align-middle">restaurant</i>&nbsp;' +
                    hl;
                } else if (x.includes("café") && !x.includes("restaurant")) {
                  hl =
                    '<i class="material-icons align-middle">restaurant</i>&nbsp;' +
                    hl;
                } else if (
                  x.includes("eateries") ||
                  x.includes("dining room") ||
                  (x.includes("restaurant") && !x.includes("bar"))
                ) {
                  hl =
                    '<i class="material-icons align-middle">restaurant</i>&nbsp;' +
                    hl;
                } else if (x.includes("bar") && x.includes("lounge")) {
                  hl =
                    '<i class="material-icons align-middle">liquor</i>&nbsp;' +
                    hl;
                }
                if (x.includes("cocktail")) {
                  hl =
                    '<i class="material-icons align-middle">local_bar</i>&nbsp;' +
                    hl;
                }
                if (x.includes("fireplace") || x.includes("fire pit")) {
                  hl =
                    '<i class="material-icons align-middle">fireplace</i>&nbsp;' +
                    hl;
                }
                if (x.includes("barbecue") || x.includes("bbq")) {
                  hl =
                    '<i class="material-icons align-middle">outdoor_grill</i>&nbsp;' +
                    hl;
                }
                if (x.includes("theatre")) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">domino_mask</i>&nbsp;' +
                    hl;
                }
                if (x.includes("museum")) {
                  hl =
                    '<i class="material-icons align-middle">museum</i>&nbsp;' +
                    hl;
                }
                if (x.includes("casino")) {
                  hl =
                    '<i class="material-icons align-middle">casino</i>&nbsp;' +
                    hl;
                }
                if (x.includes("shopping centre") || x.includes("mall")) {
                  hl =
                    '<i class="material-icons align-middle">shopping_bag</i>&nbsp;' +
                    hl;
                }
                if (x.includes("tour") && !x.includes("audiovisual")) {
                  hl =
                    '<i class="material-icons align-middle">tour</i>&nbsp;' +
                    hl;
                }
                if (x.includes("audiovisual")) {
                  hl =
                    '<i class="material-symbols-outlined  align-middle">media_output</i>&nbsp;' +
                    hl;
                }
                if (x.includes("wine")) {
                  hl =
                    '<i class="material-icons align-middle">wine_bar</i>&nbsp;' +
                    hl;
                }
                if (x.includes("*") || x.includes("accomodation")) {
                  hl =
                    '<i class="material-icons align-middle">hotel_class</i>&nbsp;' +
                    hl;
                }
                if (x.includes("golf")) {
                  hl =
                    '<i class="material-icons align-middle">golf_course</i>&nbsp;' +
                    hl;
                }
                if (x.includes("nature trail")) {
                  hl =
                    '<i class="material-icons align-middle">forest</i>&nbsp;' +
                    hl;
                }
                if (x.includes("breakfast") && !x.includes("dinner")) {
                  hl =
                    '<i class="material-icons align-middle">bakery_dining</i>&nbsp;' +
                    hl;
                }
                if (x.includes("parking")) {
                  hl =
                    '<i class="material-icons align-middle">local_parking</i>&nbsp;' +
                    hl;
                }
                if (x.includes("servicing")) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">cleaning_services</i>&nbsp;' +
                    hl;
                }
                if (x.includes("terrace") || x.includes("deck")) {
                  hl =
                    '<i class="material-icons align-middle">deck</i>&nbsp;' +
                    hl;
                }
                if (
                  x.includes("fitness") ||
                  x.includes("exercise") ||
                  x.includes("gym")
                ) {
                  hl =
                    '<i class="material-icons align-middle">fitness_center</i>&nbsp;' +
                    hl;
                }
                if (x.includes("tennis")) {
                  hl =
                    '<i class="material-icons align-middle">sports_tennis</i>&nbsp;' +
                    hl;
                }
                if (x.includes("butler")) {
                  hl =
                    '<i class="material-icons align-middle">man</i>&nbsp;' + hl;
                }
                if (x.includes("yoga")) {
                  hl =
                    '<i class="material-icons align-middle">self_improvement</i>&nbsp;' +
                    hl;
                }
                if (x.includes("beach") && x.includes("pool")) {
                  hl =
                    '<i class="material-icons align-middle">pool</i>&nbsp;' +
                    hl;
                } else if (x.includes("pool")) {
                  hl =
                    '<i class="material-icons align-middle">pool</i>&nbsp;' +
                    hl;
                } else if (
                  x.includes("beach") &&
                  !x.includes("bar") &&
                  !x.includes("tennis")
                ) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">beach_access</i>&nbsp;' +
                    hl;
                }

                if (x.includes("watersports") || x.includes("kayaking")) {
                  hl =
                    '<i class="material-icons align-middle">kayaking</i>&nbsp;' +
                    hl;
                }
                if (x.includes("surfing")) {
                  hl =
                    '<i class="material-icons align-middle">surfing</i>&nbsp;' +
                    hl;
                }
                if (x.includes("sauna") || x.includes("steam room")) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">sauna</i>&nbsp;' +
                    hl;
                }
                if (
                  x.includes("dive") ||
                  x.includes("snorkelling") ||
                  x.includes("paddle boarding")
                ) {
                  hl =
                    '<i class="material-icons align-middle">water</i>&nbsp;' +
                    hl;
                }
                if (x.includes("laundry")) {
                  hl =
                    '<i class="material-icons align-middle">local_laundry_service</i>&nbsp;' +
                    hl;
                }
                if (x.includes("cooking")) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">cooking</i>&nbsp;' +
                    hl;
                }
                if (
                  x.includes("kids’ club") ||
                  x.includes("kids' club") ||
                  x.includes("kids club")
                ) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">family_star</i>&nbsp;' +
                    hl;
                }
                if (x.includes("spa") && x.includes("jacuzzi")) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">spa</i>&nbsp;' +
                    hl;
                } else if (x.includes("jacuzzi") || x.includes("hot tub")) {
                  hl =
                    '<i class="material-icons align-middle">hot_tub</i>&nbsp;' +
                    hl;
                } else if (x.includes("spa") && !x.includes("jacuzzi")) {
                  hl =
                    '<i class="material-icons align-middle">spa</i>&nbsp;' + hl;
                }
                if (x.includes("shuttle") || x.includes("airport transfer")) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">airport_shuttle</i>&nbsp;' +
                    hl;
                }
                if (x.includes("bike")) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">pedal_bike</i>&nbsp;' +
                    hl;
                }
                if (x.includes("game drive")) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">directions_bus</i>&nbsp;' +
                    hl;
                }
                if (x.includes("chocolate")) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">redeem</i>&nbsp;' +
                    hl;
                }
                if (x.includes("safari") || x.includes("wildlife")) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">pets</i>&nbsp;' +
                    hl;
                }
                if (x.includes("petting zoo")) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">cruelty_free</i>&nbsp;' +
                    hl;
                }
                if (x.includes("art gallery")) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">palette</i>&nbsp;' +
                    hl;
                }
                if (x.includes("library")) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">book_3</i>&nbsp;' +
                    hl;
                }
                if (x.includes("crêperie")) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">egg_alt</i>&nbsp;' +
                    hl;
                }
                if (x.includes(" nature") || x.includes("culture")) {
                  hl =
                    '<i class="material-symbols-outlined align-middle">eco</i>&nbsp;' +
                    hl;
                }
                formatted_highlights.push(hl);
              });
              this.formatted_highlights = formatted_highlights.join(
                '</li><li class="p-2 px-3">'
              );
              this.highlightsHTML = `<li class="p-2 px-3">${this.formatted_highlights}</li>`;
            }
            if (json[0].description) {
              this.description = json[0].description;
              this.tfviewHTML = `${this.description}`;
            }
          }

          this.$nextTick(() => {
            this.$refs["accomodation-info-modal-ref"].show();
            setTimeout(() => {
              const gal = document.querySelector(".gal");
              const gal_closed = document.querySelector(".gal-closed");
              const gal_wrapper = document.querySelector(".gal-wrapper");
              const gal_preview = document.querySelector(".gal-preview");
              const gal_items = document.querySelector(".gal-items");
              const view_all = document.querySelector(".view-all");
              const view_preview = document.querySelector(".view-preview");
              const gal_item = document.querySelectorAll(".gal-items > li");
              const gal_img = document.querySelectorAll(
                ".gal-items > li > img"
              );
              const overlay = document.querySelectorAll(".overlay");
              const inflated = document.querySelector(".blow-up");
              const blown_up = document.querySelector(".blown-up");
              const gal_prev = document.querySelector(".gal-prev");
              const gal_next = document.querySelector(".gal-next");
              const hotel_content = document.querySelector(".hotel-content");
              function gal_open() {
                document.querySelector(".gal-main").style.display = "none";
                view_all.style.display = "none";
                view_preview.style.display = "block";
                blown_up.style.display = "none";
                gal_next.style.display = "none";
                hotel_content.classList.add("d-none");
                gal_wrapper.classList.remove("gal-closed");
                gal_wrapper.classList.add("gohigh");
                gal_wrapper.style.overflowY = "scroll";

                gal_preview.classList.remove("col-4");
                gal_items.style.gap = "10px";
                gal_item.forEach(function (el) {
                  el.style.height = "300px";
                });
                gal_img.forEach(function (el) {
                  el.style.borderRadius = "5px";
                  el.style.MozBorderRadius = "5px";
                });
                overlay.forEach(function (el) {
                  el.style.display = "flex";
                });
              }
              function gal_close() {
                document.querySelector(".gal-main").style.display = "flex";
                view_all.style.display = "block";
                hotel_content.classList.remove("d-none");
                view_preview.style.display = "none";
                gal_wrapper.classList.add("gal-closed");
                gal_wrapper.classList.remove("gohigh");
                gal_wrapper.style.overflowY = "hidden";
                gal_wrapper.scrollTop = 0;
                gal_preview.classList.add("col-4");
                gal_items.style.gap = "unset";
                gal_item.forEach(function (el) {
                  el.style.height = "100px";
                });
                gal_img.forEach(function (el) {
                  el.style.borderRadius = "unset";
                  el.style.MozBorderRadius = "unset";
                });
                overlay.forEach(function (el) {
                  el.style.display = "none";
                });
              }
              function blow_up() {
                event.target.parentElement.classList.add("blow-up");
                gal_wrapper.style.height = "auto";
                gal_wrapper.classList.remove("gohigh");
                gal_wrapper.style.overflowY = "hidden";
                gal.style.marginBottom = "-20px";
                gal_items.style.gap = "unset";
                const img_hide = document.querySelectorAll(
                  ".gal-img:not(.blow-up)"
                );
                img_hide.forEach(function (el) {
                  el.style.display = "none";
                });
                view_preview.style.display = "none";
                blown_up.style.display = "block";
                overlay.forEach(function (el) {
                  el.style.display = "inline-block";
                  el.style.height = "unset";
                  el.style.top = "unset";
                  el.style.bottom = "0";
                  el.style.padding = "10px";
                  el.style.textAlign = "center";
                  el.style.transform = "unset";
                  el.style.transition = "unset";
                });
                gal_prev.style.display = "block";
                gal_next.style.display = "block";
              }

              function deflate() {
                gal_wrapper.style.height = "";
                gal_wrapper.classList.add("gohigh");
                gal_wrapper.style.overflowY = "scroll";
                gal.style.marginBottom = "0";
                gal_items.style.gap = "10px";
                gal_item.forEach(function (el) {
                  el.classList.remove("blow-up");
                  el.style.display = "flex";
                });
                overlay.forEach(function (el) {
                  el.removeAttribute("style");
                  el.style.display = "flex";
                });
                view_preview.style.display = "block";
                blown_up.style.display = "none";
                gal_prev.style.display = "none";
                gal_next.style.display = "none";
              }

              const pictures = gal_item;

              let position = 0;
              if (!pictures.length) return;
              pictures[position].style.display = "block";

              function hideIMG() {
                pictures[position].classList.add("blow-up");
                pictures[position].style.display = "block";
                for (let i = 0; i < pictures.length; i++) {
                  if (i !== position) pictures[i].style.display = "none";
                  if (i !== position) pictures[i].classList.remove("blow-up");
                }
              }

              function control() {
                if (position >= 0 && position < pictures.length) {
                  hideIMG();
                } else if (position === pictures.length) {
                  position = 0;
                  hideIMG();
                } else {
                  position = pictures.length - 1;
                  hideIMG();
                }
              }

              function next_img() {
                position++;
                control();
              }
              function prev_img() {
                position--;
                control();
              }
              gal_prev.addEventListener("touchstart", trigger_gal_prev);
              gal_prev.addEventListener("click", trigger_gal_prev);
              function trigger_gal_prev(event) {
                prev_img();
              }
              gal_next.addEventListener("touchstart", trigger_gal_next);
              gal_next.addEventListener("click", trigger_gal_next);
              function trigger_gal_next(event) {
                next_img();
              }
              setTimeout(() => {
                gal_closed.addEventListener("touchstart", trigger_gal_open);
                gal_closed.addEventListener("click", trigger_gal_open);
                function trigger_gal_open(event) {
                  if (event.currentTarget.classList.contains("gal-closed")) {
                    event.stopPropagation();
                    gal_open();
                  }
                }
              }, 333);

              view_preview.addEventListener("click", function (event) {
                if (event.currentTarget === view_preview) {
                  event.stopPropagation();
                  gal_close();
                }
              });

              overlay.forEach((over) =>
                over.addEventListener("click", (event) => {
                  event.stopPropagation();
                  blow_up();
                })
              );
              gal_img.forEach((img) =>
                img.addEventListener("touchstart", (event) => {
                  event.stopPropagation();
                  blow_up();
                })
              );

              blown_up.addEventListener("click", function (event) {
                if (event.currentTarget === blown_up) {
                  event.stopPropagation();
                  deflate();
                }
              });
            }, 333);
          });
        });
    },
  },
};
</script>
